import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { NorthlineDesktop, NorthlineMobileSite } from "../BusinessMocks";
import { AutoScrollingPhone } from "./AutoScrollingPhone";

export const HeroSection = () => (
  <section
    className="pt-28 sm:pt-32 lg:pt-36 pb-16 lg:pb-24 border-b border-[color:var(--border-soft)]"
    data-testid="hero-section"
  >
    <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
      {/* Section header row */}
      <div className="grid grid-cols-12 gap-6 items-baseline mb-10 lg:mb-14">
        <div className="col-span-6 flex items-center gap-3">
          <span className="grid-ref">§ 01 / Ready</span>
        </div>
        <div className="col-span-6 flex justify-end">
          <span className="stamp stamp-ink hidden md:inline-flex">Built properly · Day one</span>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-8 lg:gap-12 items-start">
        {/* LEFT — copy */}
        <div className="col-span-12 lg:col-span-6">
          <h1 className="h-xl text-[color:var(--ink)]">
            Look professional.<br />
            <span className="font-serif-italic">Win more work.</span><br />
            Get paid faster.
          </h1>

          <div className="mt-8 max-w-[520px]">
            <div className="h-px bg-[color:var(--border)] w-16 mb-6" />
            <p className="copy-lg text-[color:var(--muted)]">
              Your brand, website, local Google setup and invoicing system —
              all built and managed by ReadyTrades.
            </p>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link to="/get-started" className="btn-primary text-[15px]" data-testid="hero-cta-primary">
              Get Your Free Website Preview <ArrowRight size={16} />
            </Link>
            <a href="#what-you-get" className="text-[14px] font-semibold text-[color:var(--ink)] annotation" data-testid="hero-cta-secondary">
              See what's included
            </a>
          </div>

          <div className="mt-8 flex items-center gap-3">
            <span className="w-8 h-px bg-[color:var(--accent)]" />
            <p className="text-[13px] text-[color:var(--muted)]">
              No large upfront cost. No technical experience needed.
            </p>
          </div>
        </div>

        {/* RIGHT — desktop mock stays primary; small phone overlays bottom-right on md+, stacks below on mobile */}
        <div className="col-span-12 lg:col-span-6" data-testid="hero-case-study">
          <figure aria-label="Example ReadyTrades project — Northline Plumbing & Heating, Liverpool" className="relative">
            <div className="md:pr-[110px] lg:pr-[130px]">
              <NorthlineDesktop />
            </div>
            <div className="mt-4 md:mt-0 md:absolute md:right-0 md:-bottom-8" data-testid="northline-mobile-preview">
              <div className="ml-auto md:ml-0 w-[124px] md:w-[168px]">
                <AutoScrollingPhone screenHeight={280}>
                  <NorthlineMobileSite />
                </AutoScrollingPhone>
              </div>
            </div>
            <figcaption className="mt-6 md:mt-8 flex items-center justify-between text-[color:var(--muted)]">
              <span className="grid-ref">FIG. 01 — Northline Plumbing &amp; Heating</span>
              <span className="stamp stamp-accent">Sample build · Liverpool</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </section>
);
